import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { fadeInAnimation } from 'app/core/route-animation/route.animation';
import { CommonUtilService } from 'app/services/commonUtil.service';
import { ReportService } from 'app/services/report.service';
import { SpinnerService } from 'app/services/spinner.service';
import { RegisterService } from 'app/services/user/register.service';
import { STATUS } from 'app/components/models/constants';
import { AuthService } from 'app/services/auth.service';
import { PaymentService } from 'app/services/payment.service';

@Component({
  selector: 'ms-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
  encapsulation: ViewEncapsulation.None,
  host: {
    "[@fadeInAnimation]": 'true'
  },
  animations: [fadeInAnimation]
})
export class DashboardComponent implements OnInit {

  reportDataCounts: any;
  paymentDataCounts: any;
  dataJson: any;
  public multi: any[];

  public showXAxis = true;
  public showYAxis = true;
  public gradient = true;
  public showLegend = false;
  public showXAxisLabel = true;
  public xAxisLabel = 'Tempo (mese/giorni)';
  public showYAxisLabel = true;
  public yAxisLabel = 'Numeri';
  public colorScheme = {
    domain: ['#32936f', '#e83f6f', '#ffbf00 ', '#2274a5']
  };
  public autoScale = true;

  frequency: any = 'DAILY';
  state: any = 'ALL';
  range: any;
  rangeFrom: any;
  rangeTo: any;
  typeOfStatus = STATUS;
  candidatePercentage : any;
  totalInvoices: any;

  constructor(
    private router: Router,
    private registerService: RegisterService,
    private commonUtilService: CommonUtilService,
    private spinnerService: SpinnerService,
    private reportService: ReportService,
    private datepipe: DatePipe,
    private auth: AuthService,
    private paymentService: PaymentService) { }

  ngOnInit(): void {

    this.spinnerService.start();

    this.commonUtilService.translateLang("HRWE.PAGE_TITLE.DASHBOARD");

    this.paymentService.getPaymentValuesForDashboard(this.auth.isAdmin()).subscribe(data => {

      this.paymentDataCounts = data;

      /* console.log(this.paymentDataCounts); */
      if(this.paymentDataCounts){
        this.totalInvoices = this.paymentDataCounts.unPaidInvoices + this.paymentDataCounts.paidInvoices;
      }
      /* console.log(this.totalInvoices); */

    });

    var today = new Date();

    this.rangeFrom = this.datepipe.transform(today.setDate(today.getDate() - 30), 'yyyy-MM-dd').toString();
    this.rangeTo = this.datepipe.transform(new Date(), 'yyyy-MM-dd').toString();
    this.dataJson = {
      frequency: this.frequency,
      state: this.state,
      range: {
        rangeFrom: this.rangeFrom,
        rangeTo: this.rangeTo
      }
    };

    if (!this.auth.isAdmin()) {
      this.registerService.getCompletionResultForRegisterUser().subscribe(data => {
        /* console.log(data); */
        if (data) {
          if (!data.completedRegistration) {
            if (!data.completedProfileDetail) {
              this.router.navigate(['/registrazione/' + data.registerId + '/personalDetail']);
            } else if (!data.completedCompanyDetail) {
              this.router.navigate(['/registrazione/' + data.registerId + '/companyDetail']);
            } else if (!data.completedContractSign) {
              this.router.navigate(['/registrazione/' + data.registerId + '/contract/intro']);
            }
          }
          this.getReportCounts();
          /* console.log(this.dataJson); */
          this.getGraphDetail();
        }
        this.spinnerService.stop();
      });
    } else {

      this.getReportCounts();
      /* console.log(this.dataJson); */
      this.getGraphDetail();

      this.spinnerService.stop();
    }

  }

  getReportCounts() {
    this.reportService.getReportsCountForDashboard(this.auth.isAdmin()).subscribe(reportData => {
      /* console.log(reportData); */
      this.reportDataCounts = reportData;

      this.candidatePercentage = Math.round(this.reportDataCounts.completedCandidates*100/this.reportDataCounts.allCandidates);

    });
  }

  getGraphDetail() {

    this.reportService.getReportsForDashboardGraph(this.dataJson, this.auth.isAdmin()).subscribe(graphData => {
      /* console.log(graphData); */

      let multi = graphData.multi;

      Object.assign(this, { multi });

    });

  }

  onSelect(event) {
    console.log(event);
  }

  filterGraph(event) {

    /* console.log(event.target.value); */

    /* console.log(event.target.name); */

    if (event.target.name === 'frequency') {
      this.frequency = event.target.value;
    }

    if (event.target.name === 'typeOfStatus') {
      this.state = event.target.value;
    }

    if (event.target.name === 'fromDate') {
      this.rangeFrom = this.datepipe.transform(event.target.value, 'yyyy-MM-dd');
    }

    if (event.target.name === 'toDate') {
      this.rangeTo = this.datepipe.transform(event.target.value, 'yyyy-MM-dd');
    }

    this.dataJson = {
      frequency: this.frequency,
      state: this.state,
      range: {
        rangeFrom: this.rangeFrom,
        rangeTo: this.rangeTo
      }
    };

    this.getGraphDetail();

  }

}
